<template>
    <card-component title="Ingresa el código" icon="message" :has-card-header-background="true" :has-button-slot="true">
      <b-loading :is-full-page="true" :active.sync="isLoading"/>
      <form @submit.prevent="submit" method="POST">
        <b-field :label="labelText">
          <b-input v-model="code" name="code" validation-message="Ingresa un número de código válido de 5 dígitos"
                pattern="^\d{5}$" required autofocus/>
        </b-field>
        <a @click="sendMessage">Volver a enviar código</a>
        <br>
        <br>
        <div >
          <b-button  class="button is-primary" @click="verifyCode()"  expanded >
            Cambia tu contraseña en WP
          </b-button>
        </div>
      </form>
      <b-modal :active.sync="isImageModalActive" has-modal-card>
        <div class="modal-card" style="width: auto">
            <header class="modal-card-head">
            <b-icon
                    icon="exclamation-thick"
                    size="is-small">
                </b-icon>
                <p class="modal-card-title">Ten en cuenta que</p>
                <button
                    type="button"
                    class="delete"
                    @click="openModal('isImageModalActive')"/>
            </header>
            <section class="modal-card-body">
            <p>
                Se confirmó correctamente el código, te redirigimos a Workplace para que cambies la contraseña.
            </p>
            </section>
            <footer class="modal-card-foot is-flex justify-content-end">
                <b-button
                    @click="requestTokenWeb()"
                    label="OK"
                    type="is-primary" />
            </footer>
        </div>
      </b-modal>
    </card-component>
</template>

<script>
import { mapState } from 'vuex'
import CardComponent from '@/components/CardComponent'
import TokenRepository from '@/services/TokenRepository'

export default {
  name: 'EnterCode',
  components: { CardComponent },
  data () {
    return {
      isImageModalActive: false,
      code: null,
      isLoading: false
    }
  },
  computed: {
    ...mapState([
      'idUser',
      'phoneNumber'
    ]),
    labelText () {
      return 'Se acaba de enviar un mensaje de texto con un código de verificación a tu celular. Ingrésalo aquí y presiona el botón para cambiar tu contraseña en Workplace'
    }
  },
  created () {
    if (this.idUser === null) {
      this.$router.push('/start-claim')
    }
  },
  methods: {
    openModal (modalName) {
      const pattern = /^\d{5}$/
      const matchesPattern = pattern.test(this.code)
      if (!matchesPattern) {
        return
      }
      console.log('Se hizo clic en el botón Activar Cuenta')
      this[modalName] = !this[modalName]
      console.log(this[modalName])
    },
    verifyCode () {
      console.log(this.code)
      TokenRepository.validateCodeSMS(this.idUser, { sms_token: this.code })
        .then((r) => {
          console.log('open modal')
          this.openModal('isImageModalActive')
        }).catch(e => {
          this.showError(e.response.data.detail)
          return false
        })
    },
    sendMessage () {
      TokenRepository.requestCodeSMS(this.idUser)
        .then((r) => {
          this.$buefy.toast.open({
            message: 'Hemos enviado un nuevo código SMS a tu celular',
            type: 'is-info'
          })
        }).catch(e => {
          this.showError(e.response.data)
        })
    },
    showError (message) {
      this.$buefy.dialog.alert({
        title: 'Error',
        message: message,
        type: 'is-danger',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    requestToken (data) {
      TokenRepository.requestTokenSMS(this.idUser, data)
        .then((r) => {
          this.$store.commit('removeIDUser')
          window.location.replace(r.data.url_to_claim)
        }).catch(e => {
          this.showError(e.response.data.detail)
        })
    },
    requestTokenWeb () {
      this.isLoading = true
      console.log(this.phone)
      TokenRepository.requestTokenWeb(
        this.idUser, {}
      ).then((r) => {
        // Here we re direct!
        this.requestToken(r.data)
      }).catch(e => {
        this.isLoading = false
        this.$buefy.toast.open({
          message: `Error: ${e.response.data.detail}`,
          type: 'is-danger'
        })
      })
    }
  }
}
</script>
